// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AlertWrapper_wrapper__3WbDe"};